export const TopEventType = {
    BetBuilder: 'bet-builder',
    Offer: 'offer',
} as const;
export type TopEventType = typeof TopEventType[keyof typeof TopEventType];
